import { Outlet } from "react-router-dom";
import styles from "@/styles/layout.module.css";
import { layoutBackgrounds } from "@/assets";

export default function ProfileLayoutRoute() {
  return (
    <div className={styles.profileLayout} style={layoutBackgrounds.profile}>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
